<template>
    <div class="animated fadeIn">
        <b-card>
              <b-card header="Medidas">
                <b-form @submit.stop.prevent="onSubmit">

                  <div class="animated fadeIn">

                    <b-row>
                      <b-col md="4">
                        <b-form>
                          <b-form-group
                          description="Altura em centímetros. Ex: 170 = 1,70 m"
                          label="Altura"
                          label-for="height"
                          :label-cols="3"
                          :horizontal="true">
                          <div class="d-flex">
                            <b-form-input v-model="currentItem.height" id="height" type="number" ></b-form-input>
                          </div>
                        </b-form-group>          
                        </b-form>
                      </b-col>

                      <b-col md="4">
                        <b-form>
                          <b-form-group
                          description="Peso em quilogramas. Ex: 70"
                          label="Peso"
                          label-for="weight"
                          :label-cols="3"
                          :horizontal="true">
                          <div class="d-flex">
                            <b-form-input v-model="currentItem.weight" id="weight" type="number"></b-form-input>
                          </div>
                        </b-form-group>          
                        </b-form>
                      </b-col>
                    </b-row>

                  
                  </div>
                </b-form>
              </b-card>


              <b-card header="Vestuário">
                <b-form @submit.stop.prevent="onSubmit">

                  <div class="animated fadeIn">
  
                    <b-row>
                      <b-col md="4">
                        <b-form>
                          <b-form-group
                          description="PP / P / M / G / GG / GGG"
                          label="Camisa"
                          label-for="shirtSize"
                          :label-cols="3"
                          :horizontal="true">
                          <div class="d-flex">
                            <b-form-input v-model="currentItem.shirtSize" id="shirtSize" type="text"></b-form-input>
                          </div>
                        </b-form-group>          
                        </b-form>
                      </b-col>

                      <b-col md="4">
                        <b-form>
                          <b-form-group
                          description=""
                          label="Calça"
                          label-for="pantSize"
                          :label-cols="3"
                          :horizontal="true">
                          <div class="d-flex">
                            <b-form-input v-model="currentItem.pantSize" id="pantSize" type="number"></b-form-input>
                          </div>
                        </b-form-group>          
                        </b-form>
                      </b-col>

                      <b-col md="4">
                        <b-form>
                          <b-form-group
                          description=""
                          label="Calçado"
                          label-for="shoeSize"
                          :label-cols="3"
                          :horizontal="true">
                          <div class="d-flex">
                            <b-form-input v-model="currentItem.shoeSize" id="shoeSize" type="number"></b-form-input>
                          </div>
                        </b-form-group>          
                        </b-form>
                      </b-col>
                    </b-row>

                  </div>

                


                </b-form>
              </b-card>

              <b-input-group class="mb-4">
                  <div class="text-danger" v-if="this.errorMessage && this.errorMessage != ''"><i class="fa fa-exclamation-triangle fa-lg mt-4"></i> {{ this.errorMessage }}</div>
              </b-input-group>

              <div slot="footer" class="text-right">
                <b-button variant="github" class="mr-1 btn-brand" @click="saveItem()"><i class="fa fa-check"></i><span>Salvar Dados Pessoais</span></b-button>
              </div>
          </b-card>
    </div>
  </template>
  
  <script>
  import Vue from 'vue'
  import axios from "axios";
  
  /* Toast */
  import VueNotifications from 'vue-notifications'
    import miniToastr from 'mini-toastr'// https://github.com/se-panfilov/mini-toastr
    //import { table } from 'console'
    
    const toastTypes = {
      success: 'success',
      error: 'error',
      info: 'info',
      warn: 'warn'
    }
    
    miniToastr.init({types: toastTypes})
    
    function toast ({title, message, type, timeout, cb}) {
      return miniToastr[type](message, title, timeout, cb)
    }
    
    const options = {
      success: toast,
      error: toast,
      info: toast,
      warn: toast
    }
    VueNotifications.setPluginOptions(options)
    
    Vue.use(VueNotifications, options)
    /* Toast - End */
  
    export default {
      name: 'PersonPersonalDataComponent',
      props: {
         item: {}
      },
      computed: {
          selectedItem() {
              return this.item
          }
      },
      components: {
      },
      data: () => {
          return {
            currentItem: {},
            errorMessage: ''
          }
      },
      methods: {
        async saveItem() {
          var s = this;
          var currentUser = this.$store.state.currentUser
          this.currentItem.id = this.selectedItem.id
          this.currentItem.uid = currentUser.id
          this.currentItem.sid = currentUser.sid

          await axios.post(
              this.$store.state.ws_url + "/person/data",
              this.currentItem
          ).then(function() {

            toast ({
              type: VueNotifications.types.success,
              title: 'Dados Pessoais',
              message: 'Dados pessoais salvos com sucesso.',
              timeout: 5000
            })

          }).catch(function (error) {
            console.log(error);

            toast ({
              type: VueNotifications.types.error,
              title: 'Dados Pessoais',
              message: error.response && error.response.data && error.response.data.message ? error.response.data.message : 'Sem permissão de acesso.',
              timeout: 5000
            })
            
          });

        }

      },
      mounted: function() {
        this.currentItem = (this.selectedItem.personData ? this.selectedItem.personData : {})
      }


    }
  
  </script>